import React, { useEffect, useState, memo } from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import coverpage from '../../assets/img/Cover.png';
import '../../assets/style/CarouselStyle.css';
import axios from 'axios';

const MainCarousel = memo(() => {
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseUrl = 'https://mis.drtrefi.edu.ph/public/images/banners/';

  useEffect(() => {
    let isMounted = true;

    const fetchBannersFromApi = async () => {
      try {
        const { data } = await axios.get(
          'https://mis.drtrefi.edu.ph/api/banner?display_site=rtr&limit=7'
        );

        if (!isMounted) return;

        const validBanners =
          data?.results?.filter(
            (b) => b?.banner_image && b.banner_image.trim() !== ''
          ) || [];

        setBanners(validBanners);
      } catch (error) {
        console.error('Error fetching banners:', error);
        if (isMounted) setBanners([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchBannersFromApi();

    const intervalId = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);

  const handleImageError = (e) => {
    // prevent infinite loop if fallback also fails
    if (e.target.src !== coverpage) {
      e.target.src = coverpage;
    }
  };

  return (
    <>
      <div className="cover d-flex align-items-center justify-content-between">
        <div className="logo">
          <img src={coverpage} alt="Cover" />
        </div>
        <div className="real-time">
          Philippine Standard Time:&nbsp;&nbsp;{currentTime}
        </div>
      </div>

      <Carousel fade interval={3000}>
        {loading ? (
          <Carousel.Item>
            <div className="carousel-placeholder">Loading banners...</div>
          </Carousel.Item>
        ) : banners.length === 0 ? (
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={coverpage}
              alt="Default banner"
            />
          </Carousel.Item>
        ) : (
          banners.map((banner, index) => {
            const imageUrl = `${baseUrl}${banner.banner_image}`;

            return (
              <Carousel.Item key={banner.id ?? index}>
                <img
                  className="d-block w-100"
                  src={imageUrl}
                  alt={`Slide ${index + 1}`}
                  loading="lazy"
                  onError={handleImageError}
                />
              </Carousel.Item>
            );
          })
        )}
      </Carousel>
    </>
  );
});

export default MainCarousel;